import {ReactNode} from 'react';
import {Navigate} from 'react-router-dom';
import {Alert} from '@mantine/core';
import {PlatformLoader} from '@flexinet/ui-components';
import {useVerifiedPermissions} from '@flexinet/auth-components';

// FNP-1359: a route gate that can tell "not allowed" from "not known yet".
//
// ⚠️ THE BUG THIS EXISTS TO PREVENT. Gating a route directly on
// `allowedActions.includes(action)` is wrong on a COLD LOAD. The array starts
// empty and fills in only after AVP answers, so `includes()` returns false for
// the first render and a `<Navigate>` in the false branch fires before the
// answer arrives. Deep links, bookmarks and a plain browser refresh all bounce
// to /dashboard; clicking through the menu works, because by then the array is
// populated. An empty array and a genuine denial are the same value, so the
// caller cannot distinguish them — this component reads `authorizing` instead,
// which the provider has always published and nothing consumed.
export const RequirePermission = (
    {
        action,
        children,
        redirectTo = '/dashboard',
        denied,
    }: {
        action: string,
        children: ReactNode,
        redirectTo?: string,
        // FNP-826: rendered in place of the redirect. For the route every
        // redirect ends on (/dashboard), where redirecting again would loop.
        denied?: ReactNode,
    }) => {

    const {authorizing, allowedActions, status} = useVerifiedPermissions();

    // Undecided. Hold the route rather than answering with a guess.
    if (authorizing) {
        return <PlatformLoader message='Checking permissions...'/>;
    }

    // Interim until FNP-1749. AVP could not be asked (FNP-1721). That is not a
    // denial, so do not redirect as if it were one.
    if (status === 'failed') {
        return <Alert color='red' title="Couldn't check your permissions"/>;
    }

    if (!allowedActions.includes(action)) {
        return denied ?? <Navigate to={redirectTo}/>;
    }

    return children;
};
